import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportFooter = ({ calculationDate, pageNumber = 1, totalPages = 1 }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="bg-white border-t border-gray-200 mt-8 pt-6 print:border-gray-400 print:mt-6 print:pt-4">
      {/* Footer Information */}
      <div className="flex flex-col md:flex-row justify-between items-center pt-4 border-t border-gray-200 print:border-gray-400">
        <div className="flex items-center space-x-4 mb-4 md:mb-0">
          <div className="flex items-center space-x-2">
            <div className="flex items-center justify-center w-6 h-6 bg-primary rounded print:bg-gray-800">
              <Icon name="Calculator" size={14} color="white" />
            </div>
            <span className="text-sm font-medium text-gray-900">Small Business Accounting Services</span>
          </div>
        </div>
        
        <div className="flex items-center space-x-6 text-sm text-gray-500">
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>Generated: {calculationDate}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="FileText" size={14} />
            <span>Page {pageNumber} of {totalPages}</span>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center pt-4 border-t border-gray-100 mt-4 print:border-gray-300">
        <p className="text-xs text-gray-400">
          © {currentYear} Small Business Accounting Services. All rights reserved. | Professional financial calculation software.
        </p>
      </div>
    </div>
  );
};

export default ReportFooter;